<script setup lang="ts">
import logoOnDark from '../assets/servepod-logo-on-dark.png';
import logoOnLight from '../assets/servepod-logo-on-light.png';
import icon from '../assets/servepod-icon.png';

/**
 * The ServePod brand mark: the full wordmark, or the cube on its own.
 *
 * The wordmark's "Serve" is white, which vanishes on the light theme, so a second copy
 * drawn in the light theme's ink is swapped in by the `data-theme` rules in tokens.css.
 * Both copies are in the DOM; CSS shows one. Choosing in script would need the theme
 * store, and would paint the wrong one for a frame before it resolved.
 */
withDefaults(
  defineProps<{
    variant?: 'wordmark' | 'icon';
    /** Rendered height in CSS pixels; the width follows the artwork. */
    height?: number;
  }>(),
  { variant: 'wordmark', height: 28 },
);
</script>

<template>
  <img
    v-if="variant === 'icon'"
    :src="icon"
    alt="ServePod"
    class="shrink-0"
    :style="{ height: `${height}px`, width: `${height}px` }"
  />
  <span v-else class="inline-flex shrink-0 items-center">
    <img
      class="sp-logo-on-dark"
      :src="logoOnDark"
      alt="ServePod"
      :style="{ height: `${height}px`, width: 'auto' }"
    />
    <img
      class="sp-logo-on-light"
      :src="logoOnLight"
      alt="ServePod"
      :style="{ height: `${height}px`, width: 'auto' }"
    />
  </span>
</template>
